/// <summary>
/// This object is a generalization of the vcTemplate to for the Email Export Menu <br/>

///  It gathers all the options and sends them to the server plus shows the preview
/// Author: MWI<br />
/// Date: 24.02.2016<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 20.07.2016                                               *<br />
/// **********************************************************************<br />
/// * - memberships                                          *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 3.03.2016                                               *<br />
/// **********************************************************************<br />
/// * -  jsLint and documentation                                         *<br />
/// * -  added getOptions function                                        *<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 24.02.2016                                               *<br />
/// **********************************************************************<br />
/// * -  inherited from template.js                                       *<br />
/// **********************************************************************<br />
/// </summary>

function Exports() { }
Exports.prototype = new vcTemplate();

Exports.prototype.init = function () {
    ///<summary>
    ///initializes the object by loading the editor <br/>
    /// creating the various event handlers and the dropdowns 
    ///</summary>
    var me = this;
    try {
        me.showInfo("", "", false);
        //init the click handler
        me.visual.find('#btnReload').off("click").on("click", function () { me.reload(); });
        //set change on options for not loaded
        me.visual.find('.chb, .ddl').off("change").on("change", function () { me.setDirty(true); });
        me.visual.find(".ddl").chosen({ "placeholder_text_multiple": me.resources.select, "no_results_text": me.resources.noEntriesExist });

        me.visual.find('.widget-export-icon').on("click", function () { me.export(this); });

      
        
        me.reload();
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};

Exports.prototype.reload = function () {
    ///<summary>
    ///clickhandler function for the reload Button <br/>
    ///</summary>
    var me = this;
    try {
        //load everything and send it to the server
        me.visual.find('#tblList .header-fixed').remove();
        me.visual.find('.widget-export-menu, .widget-export-file').toggle();
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", 1, 2, JSON.stringify(me.getOptions()),
            function (result) {
                var res = JSON.parse(result);
                if (res.noError === false) {
                    me.showInfo(res.returnHtml, true);
                } else {
                    me.showInfo("", "", false);
                    me.visual.find('#tblList').append(res.returnHtml);
                }
                me.setDirty(false);


                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }
};

Exports.prototype.export = function (object) {
    ///<summary>
    ///call the export function <br/>
    ///</summary>
    var me = this;
    try {
      
        me.visual.find('.widget-export-loading').toggleClass("show", true);
        window.VisualCoreService.exportData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", 2, 2, JSON.stringify(me.getOptions()),
            function (result) {
                if (result.length > 0) {
                    me.visual.find('.widget-export-file').show();
                    //set the export file link as href and set a export name
                    me.visual.find('.exportFile').attr('href', result).attr("download", "Export." + object.title).text('Export.' + object.title);

                } else {
                    me.showInfo("Error Exporting current List", "", true);
                }
                me.visual.find('.widget-export-loading').toggleClass("show", false);
                return false;
            });
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }
};

Exports.prototype.setDirty = function (bDirty) {
    ///<summary>
    ///set the reloadUserButton text and icon to either loaded or reload based on bDirty <br/>
    ///</summary>
    var me = this;
    try {
        if (bDirty) {
            me.visual.find("#btnReload").html("<i class='fa fa-sync-alt'></i><br />" + me.resources.reload);
        } else {
            me.visual.find("#btnReload").html("<i class='fa fa-check'></i><br />" + me.resources.loaded);
        }
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }
};

function ExportActivity() { }
ExportActivity.prototype = new Exports();

ExportActivity.prototype.init = function () {
    ///<summary>
    ///initializes the object by loading the editor <br/>
    /// creating the various event handlers and the dropdowns 
    ///</summary>
    var me = this;
    try {
        me.showInfo("", "", false);
        //init the click handler
        me.visual.find('#btnReload').off("click").on("click", function () { me.reload(); });
        //set change on options for not loaded
        me.visual.find('.chb, .ddl').off("change").on("change", function () { me.setDirty(true); });
        me.visual.find(".ddl").chosen({ "placeholder_text_multiple": me.resources.select, "no_results_text": me.resources.noEntriesExist });

        me.visual.find('.widget-export-icon').on("click", function () { me.export(this); });


        //init the vcDate
        me.visual.find("#div-date-box").vcDate({ mode: "Range", align: "right", interval: 1, langID: me.userLangidForCulture});


        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


ExportActivity.prototype.getOptions = function () {
     ///<summary>
    ///creates the object options object for the list and the xls export functions <br/>
    ///</summary>
    var me = this;
    var options = {}

    if (me.visual.find('#ddlDone').chosen().val() !== null) {
        options.DoneList = [parseInt(me.visual.find('#ddlDone').chosen().val(),10)];
    }
  
    if (me.visual.find('#ddlScope').chosen().val() !== null) {
        options.ScopeList = [parseInt(me.visual.find('#ddlScope').chosen().val(),10)];
    }
    if (me.visual.find('#ddlAccount').chosen().val() !== null) {
        options.AccountList = [parseInt(me.visual.find('#ddlAccount').chosen().val())];
    }
    if (me.visual.find('#ddlUser').chosen().val() !== null) {
        options.UserList = me.visual.find('#ddlUser').chosen().val();
    }
    if (me.visual.find('#ddlDevice').chosen().val() !== null) {
        options.DeviceList = me.visual.find('#ddlDevice').chosen().val();
    }
    var dates = me.visual.find("#div-date-box").vcDate("getDateRange");
    options.StartDate = dates.from;
    options.EndDate = dates.to;

  
    return options;
};



function ExportUser() { }
ExportUser.prototype = new Exports();

ExportUser.prototype.getOptions = function () {
    ///<summary>
    ///creates the object options object for the list and the xls export functions <br/>
    ///</summary>
    var me = this;
    var options = {
        IncludeLockedOut: me.visual.find('#chbLockedOut').prop("checked"),
        IncludeUnregistered: me.visual.find('#chbNotRegistered').prop("checked"),
        IncludeDeleted: me.visual.find('#chbDeleted').prop("checked")
    };
    if (me.visual.find('#ddlMembershipInc').chosen().val() !== null) {
        options.membershipInc = me.visual.find('#ddlMembershipInc').chosen().val();
    }
    if (me.visual.find('#ddlMembershipExcl').chosen().val() !== null) {
        options.membershipExcl = me.visual.find('#ddlMembershipExcl').chosen().val();
    }
   
    return options;
};



function ExportIntervention() { }
ExportIntervention.prototype = new Exports();

ExportIntervention.prototype.init = function () {
    ///<summary>
    ///initializes the object by loading the editor <br/>
    /// creating the various event handlers and the dropdowns 
    ///</summary>
    var me = this;
    try {
        me.showInfo("", "", false);
        //init the click handler
        me.visual.find('#btnReload').off("click").on("click", function () { me.reload(); });
        //set change on options for not loaded
        me.visual.find('.chb, .ddl').off("change").on("change", function () { me.setDirty(true); });
        me.visual.find(".ddl").chosen({ "placeholder_text_multiple": me.resources.select, "no_results_text": me.resources.noEntriesExist });

        me.visual.find('.widget-export-icon').on("click", function () { me.export(this); });
       

        //init the vcDate
        me.visual.find("#div-date-box").vcDate({ mode: "Range", align: "right", interval: 1, langID: me.userLangidForCulture });

       
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


ExportIntervention.prototype.getOptions = function () {
    ///<summary>
    ///creates the object options object for the list and the xls export functions <br/>
    ///</summary>
    var me = this;
    var options = {}

    if (me.visual.find('#ddlType').chosen().val() !== null) {
        options.TypeList = me.visual.find('#ddlType').chosen().val();
    }
    if (me.visual.find('#ddlUser').chosen().val() !== null) {
        options.UserList = me.visual.find('#ddlUser').chosen().val();
    }
    if (me.visual.find('#ddlDevice').chosen().val() !== null) {
        options.DeviceList = me.visual.find('#ddlDevice').chosen().val();
    }
    var dates = me.visual.find("#div-date-box").vcDate("getDateRange");
    options.StartDate = dates.from;
    options.EndDate = dates.to;


    return options;
};


